import React from 'react';

const copyrightYear = new Date().getFullYear();
const AddressFooter = () => (
  <div>
    <p className="c-ig-text-info u-mb-6 u-mt-8 u-text-center">
      Copyright © {copyrightYear} Squire Technologies.&nbsp;
      <br className="u-hide-on-desktop" />
      All rights reserved.
      <br />
      You are receiving this email because you&apos;re awesome and because you have a Squire account.
    </p>
    <p className="c-ig-text-info u-text-center">
      Our mailing address is:<br />
      Squire Technologies<br />
      139 Eldridge St.<br />
      New York, NY 10002
    </p>
  </div>
);

export default AddressFooter;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/AddressFooter.jsx